import React from 'react';
import { AppBar } from './components/AppBar';
import Footer from './components/Footer';
import MetaTags from './components/MetaTags';
import { Container, Row, Col } from 'react-bootstrap';
import { FaRegFaceSmile } from "react-icons/fa6";
import { PiSmileySadBold } from "react-icons/pi";

const SafetyTipsOne = () => {
  return <SafetyTipsTwo />;
};

const SafetyTipsTwo = () => {
  return (
    <>
      <MetaTags
        title="Firecracker Safety Tips | Alagar Crackers Sivakasi"
        type="website"
        siteName="alagarcrackers.com"
        url="https://alagarcrackers.com/safetytips"
        keywords="Safety Tips, Sivakasi Crackers, Fireworks Safety Guidelines, Safe Diwali"
        description="Learn essential fireworks handling, lighting, and storage safety guidelines from Alagar Crackers."
        revisitAfter="10 Days"
      />
      <AppBar />
      <img src={require('../assets/images/banner/banner_three.jpg')} className='img-fluid w-100' alt='Fireworks Safety Tips' />

      {/* Header Info */}
      <div className='pt-5 pb-3 text-center'>
        <Container>
          <div className='d-inline-block px-3 py-1 bg-danger bg-opacity-10 text-danger rounded-pill fw-bold mb-3' style={{ fontSize: '13px' }}>
            🛡️ SAFE & RESPONSIBLE CELEBRATIONS
          </div>
          <h1 className='bold lg-font color-red mb-3'>Fireworks Safety Guidelines</h1>
          <p className='regular text-muted mx-auto' style={{ maxWidth: '700px', fontSize: '16px' }}>
            Diwali is a festival of joy and lights. Follow these simple safety instructions to ensure a joyful, incident-free celebration for you and your loved ones.
          </p>
        </Container>
      </div>

      {/* Do's Section */}
      <div className='padding pt-4'>
        <Container>
          <div className='text-center mb-5'>
            <div className='title bg-green shadow-sm'>
              <span>✅ DO'S — Safe Practices</span>
            </div>
          </div>
          <Row className='align-items-center g-4'>
            <Col lg='4' md='6'>
              <div className='p-4 bg-white rounded-4 shadow-sm border border-success border-opacity-25 mb-4'>
                <div className='d-flex align-items-center gap-3 mb-2'>
                  <div className='sft-icon'>
                    <FaRegFaceSmile size={24} />
                  </div>
                  <h5 className='bold text-dark mb-0'>Read Instructions</h5>
                </div>
                <p className='regular text-muted mb-0 small'>
                  Always read and strictly follow the warning labels and instructions printed on the cracker packaging.
                </p>
              </div>

              <div className='p-4 bg-white rounded-4 shadow-sm border border-success border-opacity-25'>
                <div className='d-flex align-items-center gap-3 mb-2'>
                  <div className='sft-icon'>
                    <FaRegFaceSmile size={24} />
                  </div>
                  <h5 className='bold text-dark mb-0'>Branded Fireworks</h5>
                </div>
                <p className='regular text-muted mb-0 small'>
                  Purchase only genuine, certified fireworks from licensed manufacturers like Alagar Crackers Sivakasi.
                </p>
              </div>
            </Col>

            <Col lg='4' className='text-center d-none d-lg-block'>
              <div className='p-3 bg-white rounded-4 shadow-sm border'>
                <img src={require('../assets/images/safetytips.png')} className='img-fluid' alt='Diwali Safety' />
                <h6 className='bold text-success mt-3 mb-0'>Light One at a Time</h6>
              </div>
            </Col>

            <Col lg='4' md='6'>
              <div className='p-4 bg-white rounded-4 shadow-sm border border-success border-opacity-25 mb-4'>
                <div className='d-flex align-items-center gap-3 mb-2'>
                  <div className='sft-icon'>
                    <FaRegFaceSmile size={24} />
                  </div>
                  <h5 className='bold text-dark mb-0'>Outdoor Spaces Only</h5>
                </div>
                <p className='regular text-muted mb-0 small'>
                  Always ignite firecrackers in open, outdoor grounds away from dry grass, parked vehicles, and overhead wires.
                </p>
              </div>

              <div className='p-4 bg-white rounded-4 shadow-sm border border-success border-opacity-25'>
                <div className='d-flex align-items-center gap-3 mb-2'>
                  <div className='sft-icon'>
                    <FaRegFaceSmile size={24} />
                  </div>
                  <h5 className='bold text-dark mb-0'>Water Bucket Ready</h5>
                </div>
                <p className='regular text-muted mb-0 small'>
                  Keep two buckets of clean water and sand nearby for emergency dousing and disposing used sparklers.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Don'ts Section */}
      <div className='padding pt-4' style={{ backgroundColor: '#fff5f5' }}>
        <Container>
          <div className='text-center mb-5'>
            <div className='title bg-red shadow-sm'>
              <span>❌ DON'TS — Avoid These Hazards</span>
            </div>
          </div>
          <Row className='align-items-center g-4'>
            <Col lg='4' md='6'>
              <div className='p-4 bg-white rounded-4 shadow-sm border border-danger border-opacity-25 mb-4'>
                <div className='d-flex align-items-center gap-3 mb-2'>
                  <div className='sft-icon red'>
                    <PiSmileySadBold size={24} />
                  </div>
                  <h5 className='bold text-dark mb-0'>Never Relight Duds</h5>
                </div>
                <p className='regular text-muted mb-0 small'>
                  Never attempt to re-ignite or pick up a firework that failed to go off. Wait 15 minutes and douse with water.
                </p>
              </div>

              <div className='p-4 bg-white rounded-4 shadow-sm border border-danger border-opacity-25'>
                <div className='d-flex align-items-center gap-3 mb-2'>
                  <div className='sft-icon red'>
                    <PiSmileySadBold size={24} />
                  </div>
                  <h5 className='bold text-dark mb-0'>No Loose Clothing</h5>
                </div>
                <p className='regular text-muted mb-0 small'>
                  Avoid wearing loose, synthetic, or flowy garments while bursting crackers. Wear fitted cotton clothes and footwear.
                </p>
              </div>
            </Col>

            <Col lg='4' className='text-center d-none d-lg-block'>
              <div className='p-3 bg-white rounded-4 shadow-sm border'>
                <img src={require('../assets/images/safetytips.png')} className='img-fluid' alt='Avoid fire hazards' />
                <h6 className='bold text-danger mt-3 mb-0'>Adult Supervision Mandatory</h6>
              </div>
            </Col>

            <Col lg='4' md='6'>
              <div className='p-4 bg-white rounded-4 shadow-sm border border-danger border-opacity-25 mb-4'>
                <div className='d-flex align-items-center gap-3 mb-2'>
                  <div className='sft-icon red'>
                    <PiSmileySadBold size={24} />
                  </div>
                  <h5 className='bold text-dark mb-0'>Never Aim at People</h5>
                </div>
                <p className='regular text-muted mb-0 small'>
                  Never throw, point, or ignite fireworks in the direction of individuals, pets, buildings, or electric lines.
                </p>
              </div>

              <div className='p-4 bg-white rounded-4 shadow-sm border border-danger border-opacity-25'>
                <div className='d-flex align-items-center gap-3 mb-2'>
                  <div className='sft-icon red'>
                    <PiSmileySadBold size={24} />
                  </div>
                  <h5 className='bold text-dark mb-0'>Never Store in Pockets</h5>
                </div>
                <p className='regular text-muted mb-0 small'>
                  Never carry loose crackers in your pockets. Store all fireworks in a closed, dry box away from matches and heat sources.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
};

export { SafetyTipsOne, SafetyTipsTwo };
